// extracted by mini-css-extract-plugin
export default {"topSlideItem":"SkeletonMainTopSlider_topSlideItem__POpGT","title":"SkeletonMainTopSlider_title__F-tEK","place":"SkeletonMainTopSlider_place__7LQzJ"};